import ServiceCRUD from '../../../services/ServiceCRUDFLEXUC';

class ContextService extends ServiceCRUD {
  constructor() {
    super('/api/contextos');
  }
}

export default new ContextService();
